import React from 'react';
import PropTypes from 'prop-types';

const RightArrow = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 5.5H10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.78516 10.2134L10.4992 5.49936L5.78516 0.785345"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

RightArrow.propTypes = {
  color: PropTypes.string.isRequired,
};

export default RightArrow;
